import React from 'react';
import Label from "./Label";
import Input from "./Inputs/Input";
import Error from "./Error";
import Select from "./Inputs/Select";
import DetailedLabel from "./DetailedLabel";
import Range from "./Inputs/Range";
import Radio from "./Inputs/Radio";
import DateInput from "./Inputs/DateInput";

const FormInput = (props) => {
    const {
        name            = '',
        label           = '',
        detailedLabel   = '',
        type            = 'text',
        error           = null,
        style           = {}
    } = props;

    const renderInput = () => {
        switch (type) {
            case 'radio':
                return (
                    <Radio {...props} />
                );
            case 'range':
                return (
                    <Range {...props} />
                );
            case 'select':
                return (
                    <Select {...props} />
                );
            case 'date':
                return (
                    <DateInput {...props} />
                );
            default:
                return (
                    <Input {...props} />
                );
        }
    }

    return (
        <div className={"form-input-container"} style={style}>
            <DetailedLabel detailedLabel={detailedLabel} />
            <div className="form-input">
                <Label name={name} label={label} />
                {renderInput()}
            </div>
            <Error error={!!error && !!error[name] ? error[name] : null} />
        </div>
    );
}

export default FormInput;
